import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAccessToken } from "@utils/authService";

const AuthGuard = ({ children }) => {
  const location = useLocation();

  // Read the token synchronously on every render (instead of via useEffect)
  // so that a client-side navigation (e.g. clicking a Link) never renders
  // protected children with stale auth state.
  const isAuth = !!getAccessToken();

  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthGuard;
